import { render } from "./EmailIcon.vue?vue&type=template&id=3b02e416"
import script from "./EmailIcon.vue?vue&type=script&lang=js"
export * from "./EmailIcon.vue?vue&type=script&lang=js"
script.render = render

export default script